import { EventData } from 'Models'
import {
  buildStaticModeRegistrationPath,
} from 'utils/helper/static-mode-route'

/** Volunteer check-in URL with static-mode path and query token. */
export function buildVolunteerRegistrationLink(
  event: Pick<EventData, '_id' | 'branchId' | 'volunteerToken'>
): string | null {
  const { _id: eventId, volunteerToken } = event
  if (!eventId || !volunteerToken) return null

  const branchId =
    event.branchId ??
    window.location.pathname.split('/').filter(Boolean)[0] ??
    ''
  if (!branchId) return null

  const url = new URL(window.location.origin)
  url.pathname = buildStaticModeRegistrationPath(branchId, eventId)
  url.searchParams.set('volunteerToken', volunteerToken)
  return url.href
}
